import React from 'react';
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import cl from "./SubscriptionCancellationsSummaryItemForm.module.css";

const SubscriptionCancellationsSummaryItemForm = ({initData}) => {

    function getItems() {
        const result = initData.reasons.map(x => ({title: x.title, count: x.count}));
        result.push({title: "Другое", count: initData.custom_count});
        return result;
    }

    function renderItem(item) {
        return <div key={item.title} className={cl.stepBodyOption}>
            <div className={cl.stepBodyOptionSummaryStatus}>
                <div className={cl.summaryCount}>&nbsp;{item.count}</div>
            </div>
            <div className={cl.stepBodyOptionSummaryStatusPercent}>
                <div className={cl.summaryPercent}>&nbsp;{getPercentText(item.count, initData.total)}</div>
            </div>
            <div className={`${cl.stepBodyOptionValue} ${cl.selected}`}>
                <p>{item.title}</p>
            </div>
        </div>
    }

    return (
        <BaseSimpleItemEditorForm>
            <FormBlock title={"Статистика причин отказов от подписки"}>
            <div className={cl.stepBlock}>
                    {getItems().map(renderItem)}
                </div>
            </FormBlock>
        </BaseSimpleItemEditorForm>
    );
};

function getPercentText(count, total) {
    const perc = count / total * 100.0;
    return `${perc.toFixed(0)}%`;
}

export default SubscriptionCancellationsSummaryItemForm;